module.exports = __webpack_public_path__ + "static/media/map_fishing_place.66cacf4c.png";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/markers/map_fishing_place.png
// module id = 2225
// module chunks = 0